
// If a user closes out of the video while it is still playing this function will pause the video for them, so the video will not continue to play after the modal is closed.
var stopAllYouTubeVideos = () => {
   var iframes = document.querySelectorAll('iframe');
   Array.prototype.forEach.call(iframes, iframe => {
   iframe.contentWindow.postMessage(JSON.stringify({ event: 'command',
   func: 'pauseVideo' }), '*');
   });
}

export function revealVideo() {
   const playButton = document.querySelector('.play-button-wrapper');
   const modal = document.querySelector('.video-modal');
   const closeModal = document.querySelector('.close-modal');
   const videos = document.querySelectorAll('iframe')

   playButton.addEventListener('click', (e) => {
      modal.classList.add('video-active');
      playButton.style.opacity = '0';
      document.body.style.overflow = "hidden";
   })
   
   closeModal.addEventListener('click', (e) => {
      modal.classList.remove('video-active');
      playButton.style.opacity = '1';
      document.body.style.overflow = "";
      stopAllYouTubeVideos();
      
   })
   
}